import {
    partnerCreditsWalletSchema,
    partnerCreditTransactionsPageSchema,
    type PartnerCreditsWallet,
    type PartnerCreditTransactionsPage,
} from '@houzy/schemas/partner-cockpit/credits';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { apiRequest } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';

export function useCreditsWallet(enabled = true): ReturnType<typeof useQuery<PartnerCreditsWallet>> {
    return useQuery({
        queryKey: ['credits', 'wallet'],
        queryFn: ({ signal }): Promise<PartnerCreditsWallet> =>
            apiRequest(partnerCockpitApiPath('credits/wallet'), {
                signal,
                responseSchema: partnerCreditsWalletSchema,
            }),
        enabled,
    });
}

export function useCreditTransactions(
    page: number,
    pageSize: number,
): ReturnType<typeof useQuery<PartnerCreditTransactionsPage>> {
    const start = page * pageSize;
    return useQuery({
        queryKey: ['credits', 'transactions', start, pageSize],
        queryFn: ({ signal }): Promise<PartnerCreditTransactionsPage> =>
            apiRequest(partnerCockpitApiPath(`credits/transactions?start=${start}&pageSize=${pageSize}`), {
                signal,
                responseSchema: partnerCreditTransactionsPageSchema,
            }),
        placeholderData: keepPreviousData,
    });
}
